module.exports = __webpack_public_path__ + "img/img_sala.5d009429.png";